import { Col, Container, Row } from "react-bootstrap";
import { BackLink, CTA, Description, Image, Title } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";

export const HeaderSideImage = ({ className, bgColor, textColor, title, titleColor, img, description, button }) => {
  return (
    <div className={clsx(className, bgColor, textColor, classes.header)}>
      <Container fluid className="mw-xxl">
        <Row>
          <Col xs={12} md={6} className={clsx(classes.header__content, "py-5")}>
            <Title className={clsx(titleColor, "mb-0")} title={title} tag="h1" />
            <div className="me-4">
              <Description className="mt-4" description={description} />
              {button?.label && (
                <CTA
                  className="mt-4"
                  label={button?.label}
                  href={button?.href}
                  variant={button?.variant}
                  target={btn.open_in_new_tab ? "_blank" : undefined}
                />
              )}
            </div>
          </Col>
          <Col xs={12} md={6} className="px-0">
            {img && <Image img={img.url} resize={false} alt={img.alt} />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderSideImage;
